import { c as _c } from "react/compiler-runtime";
import { type Dispatch, type SetStateAction, useEffect, useState } from 'react';
import type { AdvancedMentoringProductDTO } from '@/backend/modules/payment/endpoints/mutations/stripe-checkout/input.dto/input.dto';
import { ORDER_TYPE } from '@/backend/modules/payment/endpoints/mutations/stripe-checkout/types';
import type { GetAllBookingsForMonthOutputDTO } from '@/backend/modules/phone-call-booking/endpoints/queries/get-all-bookings-for-month/output.dto';
import { MENTOR_REPLY_TIME, type Subscription } from '@/common/enums';
import { calculateAdvancedMentoringPrice, DEFAULT_HOURS_WITH_MENTOR, DEFAULT_LINES_OF_CODE } from '../../../prices';
type MentoringDetails = GetAllBookingsForMonthOutputDTO['bookings'][number]['mentoringDetails'];
function toNumber(value: boolean | null | undefined): number {
  return value === true ? 1 : 0;
}
function getDefaultProduct(subscription: Subscription): AdvancedMentoringProductDTO {
  return {
    order: ORDER_TYPE.ADVANCED_MENTORING,
    price: calculateAdvancedMentoringPrice({
      hoursWithMentor: DEFAULT_HOURS_WITH_MENTOR,
      mentorReplyTime: MENTOR_REPLY_TIME.STANDARD,
      linesOfCode: DEFAULT_LINES_OF_CODE,
      applicationHelp: 0,
      careerCoaching: 0
    }),
    subscription,
    email: '',
    hoursWithMentor: DEFAULT_HOURS_WITH_MENTOR,
    mentorReplyTime: MENTOR_REPLY_TIME.STANDARD,
    linesOfCode: DEFAULT_LINES_OF_CODE,
    applicationHelp: 0,
    careerCoaching: 0,
    name: 'Mentoring spersonalizowany',
    quantity: 1
  };
}
type UseInitMentoringProductWithMentoringDetailsDataProps = {
  mentoringDetails?: MentoringDetails;
  activeSubscriptionTab: Subscription;
};
export function useInitMentoringProductWithMentoringDetailsData(t0) {
  const $ = _c(8);
  const {
    mentoringDetails,
    activeSubscriptionTab
  } = t0;
  let t1;
  if ($[0] !== activeSubscriptionTab) {
    t1 = () => getDefaultProduct(activeSubscriptionTab);
    $[0] = activeSubscriptionTab;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [advancedMentoringProduct, setAdvancedMentoringProduct] = useState(t1);
  let t2;
  let t3;
  if ($[2] !== activeSubscriptionTab || $[3] !== mentoringDetails) {
    t2 = () => {
      if (!mentoringDetails?.advancedMentoringDetails || !mentoringDetails) {
        return;
      }
      const details = mentoringDetails.advancedMentoringDetails;
      const hoursWithMentor = details.hoursWithMentor ?? DEFAULT_HOURS_WITH_MENTOR;
      const mentorReplyTime = details.mentorReplyTime ?? MENTOR_REPLY_TIME.STANDARD;
      const linesOfCode = details.linesOfCode ?? DEFAULT_LINES_OF_CODE;
      const applicationHelp = toNumber(details.applicationHelp);
      const careerCoaching = toNumber(details.careerCoaching);
      setAdvancedMentoringProduct(prev => ({
        ...prev,
        subscription: activeSubscriptionTab,
        price: calculateAdvancedMentoringPrice({
          hoursWithMentor,
          mentorReplyTime,
          linesOfCode,
          applicationHelp,
          careerCoaching
        }),
        hoursWithMentor,
        mentorReplyTime,
        linesOfCode,
        applicationHelp,
        careerCoaching
      }));
    };
    t3 = [mentoringDetails, activeSubscriptionTab];
    $[2] = activeSubscriptionTab;
    $[3] = mentoringDetails;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== advancedMentoringProduct) {
    t4 = [advancedMentoringProduct, setAdvancedMentoringProduct];
    $[6] = advancedMentoringProduct;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}